import CheckoutPayController from '@ctrls/checkoutPayController'
import RestoreOrderController from '@ctrls/restoreOrderController'
import { IonPage, IonSpinner, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew } from '@utils'
import React from 'react'
import { useLocation, useParams } from 'react-router'

const PayPalReturn = () => {
  const location = useLocation()
  const history = useHistoryNew()
  const params = useParams<{ id: string }>()
  useIonViewWillEnter(() => {
    const searchParam = new URLSearchParams(location.search)
    if (searchParam.get('token') && searchParam.get('PayerID')) {
      RestoreOrderController.clearHold()
      CheckoutPayController.holdAsyncOrder(params.id)
      history.replace(`/result/${params.id}`)
    } else if (searchParam.get('token')) {
      history.replace('/menu')
    }
    searchParam.delete('token')
    searchParam.delete('PayerID')
  })
  return <IonPage></IonPage>
}

export default PayPalReturn
